/// <reference path="../../app.ts" />

namespace Cfnc {
    "use strict";

    interface IMajorsModalScope extends ng.IScope {
        vm: IMajorsModal;
    }

    interface IMajorsModal {
        selectedFilters: Array<any>;
        majorClusters: Array<any>;
        majorCip: string;
        majorsGroup: IAvaliableFiltersGroup;
        results: Array<any>;
        cancel: () => void;
        ok: () => void;
        clusterOpen: boolean;
    }

    class MajorsModalCtrl implements IMajorsModal {
        static controllerId: string = "majorsModalCtrl";
        static $inject: Array<string> = ["campusSearchDataService", "common", "$scope", "$uibModalInstance", "selectedFilters", "majorsGroup", "majorFilter", "Restangular", "config"];
        private log;
        selectedFilters: Array<any>;
        majorClusters: Array<any>;
        majorCip: string;
        majorsGroup: IAvaliableFiltersGroup;
        results: Array<any>;
        clusterOpen: boolean;
        transitionsUrl: string;
        majorName: string;
        clonedFilters: any;

        constructor(private campusSearchDataService: ICampusSearchDataService, private common: ICommonFactory, private $scope: IMajorsModalScope, private $uibModalInstance: ng.ui.bootstrap.IModalServiceInstance, selectedFilters: IAvaliableFiltersGroup[], majorsGroup: IAvaliableFiltersGroup, majorFilter: any, private Restangular: Restangular.IService, private config: IConfig) {

            this.log = common.logger.getLogFn(MajorsModalCtrl.controllerId);
            this.activate();
            this.selectedFilters = selectedFilters;
            this.majorsGroup = majorsGroup;
            this.clonedFilters = _.cloneDeep(this.selectedFilters);
            
            if (this.selectedFilters[0].filters[0] && this.selectedFilters[0].filters[0].key =="MajorName")
                this.majorName = this.selectedFilters[0].filters[0].value;
            else
                this.majorName = '';
        }

        activate() {
            var promises = [];
            this.common.activateController(promises, MajorsModalCtrl.controllerId).then(() => {
                this.log("Activated Modal");
                this.transitionsUrl = this.config.transitionsUrl;
            });
        }

        checkArray() {
            if (_.find(this.selectedFilters, function (o) { return o.key == "ProgramsMajors" }))
                return this.selectedFilters[0].filters.length == 0 || _.find(this.selectedFilters[0].filters, { key: "MajorName" });
            else return true;
        }

        cancel() {
            this.$uibModalInstance.dismiss('cancel');
        }

        ok() {
            if (this.majorName != '') {
                var majorPillText = this.majorName.length > 20 ? "Major: " + this.majorName.substr(0, 20) + "..." : "Major: " + this.majorName;
                var filter = {
                    key: `_${this.majorName}`,
                    pillText: majorPillText,
                    value: this.majorName
                }
                this.selectedFilters = []
                this.selectedFilters.push({ filters: [filter] });
                
            }
            else if (!this.majorName) {
                _.remove(this.selectedFilters[0].filters, (o: any) => { return o.key == "MajorName" });
            }
            this.$uibModalInstance.close(this.selectedFilters);
        }

    }

    angular.module("app").controller(MajorsModalCtrl.controllerId, MajorsModalCtrl);
}